import { Button, IconButton, Text, VStack } from "@chakra-ui/react"

const LinkButton = ({ label, icon, onClick }) => (
  <VStack gap={0}>
    <IconButton
      tabIndex={-1}
      onClick={onClick}
      aria-label={label}
      variant="solid"
      size="xl"
      children={icon}
      color="gray.500"
      bgColor="white"
      rounded="full"
    />
    <Button onClick={onClick} variant="plain" aria-label={label} p={0}>
      <Text textStyle="sm" color="gray.500">
        {label}
      </Text>
    </Button>
  </VStack>
)

export default LinkButton
